import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIconCheckmarkRoundedFilledSmall = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 32 32" aria-hidden={!title && !titleId} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" fillRule="evenodd" d="M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16m7.532-19.293a1.333 1.333 0 1 0-1.886-1.886l-7.53 7.53-3.763-3.764a1.333 1.333 0 0 0-1.886 1.885l4.707 4.707c.52.52 1.365.52 1.886 0z" clipRule="evenodd" /></svg>;
export default SvgIconCheckmarkRoundedFilledSmall;